import Vue from 'vue/dist/vue.esm';
import TopNavigation from '../../vue/marketplace/top_navigation.vue';

Vue.prototype.i18n = window.i18n;

window.addEventListener('DOMContentLoaded', () => {
  const cartId = document.getElementById('marketplace-header').dataset.cartId
  if (cartId.length > 0) {
    window.cartNumberExist = cartId;
  } else {
    window.cartNumberExist = localStorage.getItem('cartNumber');
  }

  window.topNavigation = new Vue({
    el: '#marketplace-header',
    data() {
      return {
        flashMessage: null,
        flashError: null
      }
    },
    components: { TopNavigation },
    methods: {
      addMessage(message, type) {
        this.flashMessage = null;
        this.flashError = null;
        if (type == 'error') {
          this.flashError = message;
        } else {
          this.flashMessage = message;
        }
        setTimeout(() => {
          this.flashMessage = null;
          this.flashError = null;
        }, 3000);
      }
    },
  });
})